import { useDispatch } from 'react-redux'

import DialogNames from '~/constants/DialogNames'
import {
  createTeamMemberLicense,
  editTeamMemberLicense,
} from '~/store/actions/members'
import { getMembersIsUpdating } from '~/store/reducers/members'
import useDialog from '~/utils/useDialog'

export const useOpenAddLicenseDialog = (doctorId: string) => {
  const dispatch = useDispatch()
  const [openLicenseDialog] = useDialog(DialogNames.LICENSE)

  const openAddLicenseDialog = () => {
    openLicenseDialog({
      getIsLoading: getMembersIsUpdating,
      onCreateLicense: (newLicense) =>
        dispatch(createTeamMemberLicense(doctorId, newLicense)),
      onEditLicense: (newLicense) =>
        dispatch(editTeamMemberLicense(doctorId, newLicense)),
    })
  }

  return openAddLicenseDialog
}
